<template>
  <v-container fluid class="flex-column align-center justify-center px-0">
    <!-- Títulos -->
    <v-row class="g-0 " justify="center" style="width: 100%;">
      <v-col cols="12" md="12" sm="12" class="text-center">
        <h1 class="mt-8 text-5xl font-bold tracking-wide">
          TOUR ORRIA EDITATZEN 
        </h1>
        <h2 class="text-2xl mt-4 mb-8 font-medium">
          Hauek dira web orrian dauden datak:
        </h2>
      </v-col>
    </v-row>
 <v-row class="g-0 mx-0 px-0" justify="center" :style="'width: 100%'">
   
   <!-- TABLA DE CONCIERTOS -->
   <div :style="tableWrapperStyle">
     <table class="table" style="width:100%">
       <tbody style="width:100%">
         <tr v-for="(item, index) in datak" :key="index" class="row">
           <td class="cell date">{{ formatDate(item.data) }}</td>
           <td class="cell kokapena">{{ item.kokapena }}</td>
           <td class="cell pueblo">{{ item.herria }}</td>
           <td class="cell soldout">{{ item.soldout ? 'SOLDOUT' : 'sarrerak daude' }}</td>
           <td class="cell link">{{ item.link ? 'Link: ' + item.link : 'ez dago linka' }}</td>
           <td class="cell action">
             <v-icon class="mr-4" @click="openDialog('editing', item)">mdi-pencil</v-icon>
             <v-icon class="ml-4" @click="openDialog('deleting', item)">mdi-trash-can-outline</v-icon>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    
  </v-row>
    <!-- BOTÓN -->
    <v-row class="g-0 mt-4 full-width" justify="center">
      <v-col cols="12" md="8" sm="12" class="text-center mb-10">
        <v-btn prepend-icon="mdi-plus" color="primary" @click="openDialog('creating')" class="btn-custom elevation-3 px-8 py-4" large>
          SORTU DATA
        </v-btn>
      </v-col>
    </v-row>
    
    <!-- EZABATZEN CONFIRM -->
    <ConfirmDialog
      v-model="dialogs.deleting"
      title="EZABATZEN"
       :message="selectedItem
    ? `${formatDate(selectedItem.data)} ${selectedItem.kokapena} ezabatuz gero, web orritik desagertuko da, ziur zaude?`
    : 'Ez dago ezer aukeratuta.'"
      titleClass="bg-error text-white"
      confirmColor="error"
      iconColor="black"
      confirmText="EZABATU"
      cancelText="ATZERA"
      @confirm="deleteDate"
    />
    <ConfirmDialog
      :model-value="dialogs.deleted"
      @update:model-value="val => dialogs.deleted = val"
      :title="axios_error? 'ERROREA':'EZABATUTA'"
      :message="axios_error 
        ? 'Arazo bat egon da data ezabatzen, abisatu Ainhoa :/' 
        : 'Dena ongi joan da, data web-etik ezabatu duzu!'"
      :icon="axios_error ? 'mdi-alert' : 'mdi-check-circle'"
      titleClass="bg-black text-white"
      confirmText="ITXI"
      confirmColor="black"
      :iconColor="axios_error ? 'error' : 'success'"
      buttons="1"
      @confirm="closeDialog('deleted')"
/>


    <!-- EDITAR -->
    <v-dialog v-model="dialogs.editing" persistent max-width="400">
      <v-card  v-if="selectedItem">
        <v-card-title class="bg-primary text-white">EDITATZEN</v-card-title>
        <v-card-text>
          <v-form v-model="valid" @submit.prevent="submitEdit">
            <!-- Campo de fecha con date picker -->
            <v-menu v-model="menuDate" :close-on-content-click="false" transition="scale-transition" offset-y
              min-width="290px">
              <template #activator="{ props }">
                <v-text-field v-model="selectedItem.data" label="Data" v-bind="props"
                  :rules="[rules.required]"></v-text-field>
              </template>

              <v-date-picker :first-day-of-week="1" v-model="tempDate" @update:model-value="updateDate" :allowed-dates="allowedDates"  elevation="24"></v-date-picker>
            </v-menu>

            <v-text-field v-model="selectedItem.herria" :rules="[rules.required]" label="Herria/Hiria"></v-text-field>

            <v-text-field v-model="selectedItem.kokapena" :rules="[rules.required]" label="Kokapena"></v-text-field>
            <v-checkbox v-model="hasLink" label="Sarreren linka"></v-checkbox>
            <v-text-field v-if="hasLink" v-model="selectedItem.link" label="Link"></v-text-field>
            <v-switch v-model="selectedItem.soldout" color="error" label="Soldout"></v-switch>
            <v-card-actions class="justify-center">
              <v-btn type="submit" class="btn-custom elevation-3" variant="flat" color="primary">GORDE</v-btn>
              <v-btn color="black" variant="flat" class="btn-custom text-white"
                @click="closeDialog('editing')">ATZERA</v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>

      </v-card>
    </v-dialog>

    <!-- EDIT CONFIRM -->
        <ConfirmDialog
          :model-value="dialogs.editConfirmed"
          @update:model-value="val => dialogs.editConfirmed = val"
          :title="axios_error? 'ERROREA':'EDITATUTA'"
          :message="axios_error 
            ? 'Arazo bat egon da data editatzen, abisatu Ainhoa :/' 
            : 'Dena ongi joan da, data web-ean ere aldatu duzu!'"
          :icon="axios_error ? 'mdi-alert' : 'mdi-check-circle'"
          titleClass="bg-black text-white"
          confirmText="ITXI"
          confirmColor="black"
          :iconColor="axios_error ? 'error' : 'success'"
          buttons="1"
          @confirm="closeDialog('editConfirmed')"
    />

    <!-- CREAR FECHA -->
    <v-dialog v-model="dialogs.creating" persistent max-width="400">
      <v-card>
        <v-card-title class="bg-success text-white">DATA SORTZEN</v-card-title>
        <v-card-text>
          <v-form v-model="valid" @submit.prevent="submitCreate">
            <!-- Campo de fecha con date picker -->
            <v-menu v-model="menuDate" :close-on-content-click="false" transition="scale-transition" offset-y
              min-width="290px">
              <template #activator="{ props }">
                <v-text-field v-model="selectedItem.data" label="Data" v-bind="props"
                  :rules="[rules.required]"></v-text-field>
              </template>

              <v-date-picker :first-day-of-week="1" v-model="tempDate" @update:model-value="updateDate" :allowed-dates="allowedDates" elevation="24"></v-date-picker>
            </v-menu>

            <v-text-field v-model="selectedItem.herria" :rules="[rules.required]" label="Herria/Hiria"></v-text-field>

            <v-text-field v-model="selectedItem.kokapena" :rules="[rules.required]" label="Kokapena"></v-text-field>
            <v-checkbox v-model="hasLink" label="Sarreren linka"></v-checkbox>
            <v-text-field v-if="hasLink" v-model="selectedItem.link" label="Link"></v-text-field>
            <v-switch v-model="selectedItem.soldout" color="error" label="Soldout"></v-switch>
            <v-card-actions class="justify-center">
              <v-btn type="submit" class="btn-custom elevation-3" variant="flat" color="success">GORDE</v-btn>
              <v-btn color="black" variant="flat" class="btn-custom text-white"
                @click="closeDialog('creating')">ATZERA</v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>

      </v-card>
    </v-dialog>
    
        <!-- CREATE CONFIRM -->
        <ConfirmDialog
          :model-value="dialogs.createConfirmed"
          @update:model-value="val => dialogs.createConfirmed = val"
          :title="axios_error? 'ERROREA':'SORTUTA'"
          :message="axios_error 
            ? 'Arazo bat egon da data sortzen, abisatu Ainhoa :/' 
            : 'Dena ongi joan da, data web-era gehitu duzu!'"
          :icon="axios_error ? 'mdi-alert' : 'mdi-check-circle'"
          titleClass="bg-black text-white"
          confirmText="ITXI"
          confirmColor="black"
          :iconColor="axios_error ? 'error' : 'success'"
          buttons="1"
          @confirm="closeDialog('createConfirmed')"
    />

  </v-container>
</template>

<script setup>
import { ref, reactive, computed, watch, onMounted } from 'vue'
import ConfirmDialog from './ConfirmDialog.vue'

import { useTourStore } from '@/stores/tour'
import axios from 'axios'

// Store
const concertStore = useTourStore()
const datak = computed(() => concertStore.tourDatak)
const auth_token = localStorage.getItem('auth_token')


onMounted(async () => {
  try {
    const res = await axios.get('/api/tour')
    if (res.data.ok) {
      concertStore.setTourDatak(res.data.dates)
      console.log('Fechas cargadas correctamente:', res.data.dates)
    } else {
      console.error('Error al cargar las fechas:', res.data)
    }
  } catch (error) {
    console.error('Error al obtener las fechas:', error)
  }
})

// Item seleccionado
const selectedItem = ref(null)
const hasLink = ref(false)
const axios_error = ref(false)


const valid = ref(false)
const menuDate = ref(false)
const tempDate = ref(selectedItem.value?.data || '') // fecha temporal para el date picker

function updateDate(value) {
  if (!value) return
  const date = new Date(value)
  const yyyy = date.getFullYear()
  const mm = String(date.getMonth() + 1).padStart(2, '0')
  const dd = String(date.getDate()).padStart(2, '0')
  selectedItem.value.data = `${yyyy}-${mm}-${dd}`  // Formato YYYY-MM-DD
  menuDate.value = false
}

function allowedDates(val) {
  const today = new Date()
  const selected = new Date(val)

  // Permitimos solo fechas iguales o posteriores a hoy
  return selected >= today
}

const rules = {
  required: value => !!value || 'Derrigorrezkoa',
}

// Diálogos
const dialogs = reactive({
  deleting: false,
  deleted: false,
  editing: false,
  editConfirmed: false,
  creating: false,
  createConfirmed: false
})


// Funciones
function formatDate(dateString) {
  const months = ["urt", "ots", "mar", "api", "mai", "eka", "uzt", "abu", "ira", "urr", "aza", "abe"]
  const date = new Date(dateString)
  if (isNaN(date)) return ""
  const day = String(date.getDate()).padStart(2, "0")
  const month = months[date.getMonth()]
  const year = date.getFullYear()
  return `${day} ${month} ${year}`
}

async function submitEdit() {
  axios_error.value = false
  if (valid.value) {
    try {
      const res = await axios.put(`/api/tour/${selectedItem.value.id}`, selectedItem.value, {
        headers: { Authorization: `Bearer ${auth_token}` }
      });
      const data = res.data
      
      if (!data.ok) {
        axios_error.value = true
      }
      else {
        concertStore.updateTourData(selectedItem.value)
      }
    } catch (e) {
      axios_error.value = true
    } finally {
      closeDialog('editing')
      openDialog('editConfirmed')
    }
  }
}

async function submitCreate() {
  axios_error.value = false
  if (valid.value) {

    try {
      const res = await axios.post(`/api/tour/`, selectedItem.value,{
        headers: { Authorization: `Bearer ${auth_token}` }
      });
      const data = res.data
      if (!data.ok) {
        axios_error.value = true
      }
      else {
        selectedItem.value.id = data.concert.id
        concertStore.addTourData(selectedItem.value);
      }
    } catch (e) {
      axios_error.value = true
    } finally {
      closeDialog('creating')
      openDialog('createConfirmed')
    }
  }
}

function openDialog(name, item = null) {
  if (item) {
    selectedItem.value = { ...item }
    tempDate.value = item.data || ''
    hasLink.value = !!item.link  // checkbox activado si hay link
  }
  if(name == 'creating'){
    selectedItem.value = {
      data:'',
      herria:'',
      kokapena:'',
      soldout:false,
      link:''
    }
  }
  if (dialogs[name] !== undefined) dialogs[name] = true
}

function closeDialog(name) {
  valid.value = false
  if (dialogs[name] !== undefined) dialogs[name] = false
  if (name === 'deleting' || name === 'editing') selectedItem.value = null
}

async function deleteDate() {
  try {
    const res = await axios.delete(`/api/tour/${selectedItem.value.id}`, {
        headers: { Authorization: `Bearer ${auth_token}` }
      });
    const data = res.data
    if (!data.ok) {
      axios_error.value = true
    }
    else {
      concertStore.deleteTourData(selectedItem.value.id)
    }
  } catch (e) {
    console.error(e)
    axios_error.value = true
  } finally {
    closeDialog('deleting')
    openDialog('deleted')
  }

}

watch(hasLink, (newVal) => {
  if (!newVal && selectedItem.value) {
    selectedItem.value.link = ''
  }
})

// Estilo dinámico tabla
const tableWrapperStyle = computed(() => ({
  display: 'flex',
  justifyContent: 'center',
  width: '90%',
  maxHeight: datak.length > 6 ? '500px' : 'auto',
  overflowY: datak.length > 6 ? 'auto' : 'visible',
  borderRadius: '2px'
}))
</script>

<style scoped>
@media (max-width: 600px) {
  h2 {
    font-size: 0.9rem;
  }

  h1 {
    font-size: 1.4rem;
  }
}

.v-card {
  background-color: rgb(255, 255, 255);
}

h2 {
  font-weight: 500;
}

.shadow-text {
  text-shadow:
    1px 1px 2px rgba(0, 0, 0, 0.3),
    2px 2px 4px rgba(0, 0, 0, 0.2);
}

.v-container {
  background-size: cover;
  background-color: rgb(202, 245, 245);
  /* la imagen cubre todo el contenedor */
  background-position: center;
  /* centra la imagen */
  background-repeat: no-repeat;
  /* evita que se repita */
  width: 100%;
  min-height: 100vh;
}

.fade-card {
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 1s ease, transform 1s ease;
}

.fade-card[v-cloak],
.fade-card[style*="display: none"] {
  opacity: 0;
}

.fade-card[v-show="true"] {
  opacity: 1;
  transform: translateY(0);
}

.btn-custom {
  /* Tamaño grande */
  font-family: 'Inter Tight', sans-serif;
  font-size: clamp(1rem, 2.5vw, 1.5rem);
  min-height: fit-content;
  /* Borde cuadrado */
  border-radius: 0.2;

  /* Sin estilo de botón por defecto */
  text-transform: none;
  box-shadow: none;

  background-color: var(--v-primary-base);

  /* Transición para hover */
  transition: transform 0.3s ease, background-color 0.3s ease;
}

.btn-custom:hover {
  transform: translateY(-3px);
  background-color: var(--v-primary-darken1);
  /* un poco más oscuro al pasar el mouse */
}

.table {
  width: 70%;
  border-collapse: collapse;
  font-family: system-ui, Arial, sans-serif;
}

.table thead th {
  text-align: left;
  padding: 12px 16px;
  background: #f5f5f5;
  font-weight: 600;
  border-bottom: 1px solid #e0e0e0;
}

.table tbody tr {
  border-bottom: 1px solid #000000;
}

.table td {
  padding: 12px 16px;
  vertical-align: middle;
}

/* Botón simple */
.btn {
  display: inline-block;
  padding: 8px 12px;
  border-radius: 6px;
  text-decoration: none;
  background: #1976d2;
  color: white;
  font-weight: 600;
  border: none;
  cursor: pointer;
}

.btn.disabled {
  background: #aaa;
  cursor: not-allowed;
}

.table td.sarrerak {
  padding-top: 8px;
  white-space: nowrap;
}


/* PANTALLAS GRANDES */
@media (min-width: 1600px) {
  .v-container {
    background-position: center bottom 40%;
    /* o prueba con 40%, o top -80px */
  }
}


/* PANTALLAS PEQUEÑAS */
@media (max-width: 640px) {
  /* escondemos el header para liberar espacio */

  /* Convertimos cada fila en bloque con borde y padding */
  .table,
  .table tbody,
  .table tr,
  .table td {
    display: block;
    width: 100%;
  }

  .table tr {
    margin-bottom: 12px;
    border: 1px solid #000000;
    border-radius: 8px;
    padding: 12px;
    background: transparent;
    text-align: center;
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.03);
  }

  .table td {
    border: none;
  }

  /* Etiquetas visuales opcionales: ponemos la fecha más grande */
  .table td.date {
    font-weight: 700;
    font-size: 1rem;
    padding-bottom: 8px;
  }

  .table td.kokapena,
  .table td.pueblo {
    color: #000000;
    padding-bottom: 6px;
  }

  .table td.sarrerak {
    padding-top: 8px;
    white-space: nowrap;
  }

  /* Alineamos el botón a la izquierda y que ocupe todo el ancho si quieres */
  .table td.sarrerak .btn {
    width: 100%;
    text-align: center;
  }
}

.page-title {
  font-family: 'Inter Tight', sans-serif;
  font-weight: 500;
  font-size: clamp(24px, 5vw, 48px);
  margin-top: 2rem;
  margin-bottom: 2rem;
}

/* STYLE DEL SCROLLBAR */
div[style*="overflow-y: auto"] {
  scrollbar-width: thin;
  /* Firefox */
  scrollbar-color: #888 transparent;
  /* Firefox */
}

/* Chrome, Edge y Safari */
div[style*="overflow-y: auto"]::-webkit-scrollbar {
  width: 10px;
  /* ancho del scroll */
}

div[style*="overflow-y: auto"]::-webkit-scrollbar-track {
  background-color: var(--v-primary-base);
  border-radius: 10px;
}

div[style*="overflow-y: auto"]::-webkit-scrollbar-thumb {
  background-color: var(--v-primary-base);
  border-radius: 10px;
  transition: background 0.3s;
}

div[style*="overflow-y: auto"]::-webkit-scrollbar-thumb:hover {
  background-color: var(--v-primary-base);
}
</style>
